export default __webpack_public_path__ + "static/media/store-color.c2009e45.svg";